import * as React from 'react'
import {
  DesktopMac,
  PhoneIphone,
  Smartphone,
  Devices,
  RoomService,
  Security,
  LiveTv,
  LocalOffer,
  FlightTakeoff,
  Help,
  ThumbUp,
  ThumbDown,
  ThumbsUpDown,
  CloudDownload,
  VideogameAsset,
  Work,
} from 'emotion-icons/material'

export default {
  '25f761ed-a3f1-454f-99d7-e3c6aa3588a4': {
    numberOfDots: 4,
    loadingDelayPerItem: 1500,
    steps: [
      {
        title: 'What services are you intersted in?',
        options: [
          {
            icon: <DesktopMac />,
            text: 'Internet',
            key: 'internet',
            value: 'fast',
            next: 2,
            loading: {
              title: 'Brand Service',
              description: 'Internet',
            },
          },
          {
            icon: <LiveTv />,
            text: 'Direct TV',
            key: 'direct-tv',
            value: 'sateliteTv',
            next: 3,
            loading: {
              title: 'Provider',
              description: 'Direct TV',
            },
          },
          {
            icon: <Security />,
            text: 'Security',
            key: 'security',
            value: 'virus-software',
            next: 3,
            loading: {
              title: 'Bundle',
              description: 'Security',
            },
          },
          {
            icon: <Smartphone />,
            text: 'Mobile Plans',
            key: 'Mobile Plans',
            value: 'mobilePlans',
            next: 2,
            loading: {
              title: 'Bundle',
              description: 'Mobile Plans',
            },
          },
          {
            icon: <Devices />,
            text: 'Bundles',
            key: 'Bundles',
            value: 'bundles',
            next: 4,
            loading: {
              title: 'Bundles',
              description: 'Internet & TV',
            },
          },
          {
            icon: <RoomService />,
            text: 'Customer Service',
            key: 'Customer Service',
            value: 'customerService',
            link: 'https://google.com/',
            next: null,
            loading: {
              title: 'Customer Service',
              description: '',
            },
          },
        ],
      },
      {
        title: 'What sort of Package are you looking for?',
        options: [
          {
            icon: <LocalOffer />,
            text: 'Best Price',
            key: 'bundle',
            value: 'best_price',
            next: null,
            loading: {
              title: 'Looking For',
              description: 'Best Price',
            },
          },
          {
            icon: <FlightTakeoff />,
            text: 'Fastest Speed',
            key: 'speed',
            value: 'fastest_speed',
            next: null,
            loading: {
              title: 'Looking For',
              description: 'Fastest Speed',
            },
          },
          {
            icon: <Help />,
            text: 'Not Sure',
            key: 'unsure',
            value: 'unsure',
            next: null,
            loading: {
              title: 'Looking For',
              description: 'Not Sure',
            },
          },
        ],
      },
      {
        title: 'Want to bundle Internet & TV?',
        options: [
          {
            icon: <ThumbUp />,
            text: 'Yes',
            key: 'bundle-tv-internet-1',
            value: 'yes',
            next: 4,
            loading: {
              title: 'Bundle TV & Internet',
              description: 'Yes',
            },
          },
          {
            icon: <ThumbDown />,
            text: 'No',
            key: 'bundle-tv-internet-2',
            value: 'no',
            next: 4,
            loading: {
              title: 'Bundle TV & Internet',
              description: 'No',
            },
          },
          {
            icon: <ThumbsUpDown />,
            text: 'Maybe',
            key: 'bundle-tv-internet-3',
            value: 'maybe',
            next: 4,
            loading: {
              title: 'Bundle TV & Internet',
              description: 'Maybe',
            },
          },
        ],
      },
      {
        title: 'How does your household primarily use the internet?',
        options: [
          {
            icon: <CloudDownload />,
            text: 'Streaming',
            key: 'feature-1',
            value: 'streaming',
            next: null,
            loading: {
              title: 'Primary Use',
              description: 'Streaming',
            },
          },
          {
            icon: <VideogameAsset />,
            text: 'Online Gaming',
            key: 'feature-2',
            value: 'online_gaming',
            next: null,
            loading: {
              title: 'Primary Use',
              description: 'Online Gaming',
            },
          },
          {
            icon: <Work />,
            text: 'Work',
            key: 'feature-3',
            value: 'work',
            next: null,
            loading: {
              title: 'Primary Use',
              description: 'Work',
            },
          },
          {
            icon: <PhoneIphone />,
            text: 'Other',
            key: 'other',
            value: 'other',
            next: null,
            loading: {
              title: 'Primary Use',
              description: 'Other',
            },
          },
        ],
      },
      {
        title: 'What type of channels are you most interested in?',
        options: [
          {
            icon: <PhoneIphone />,
            text: 'Sports Channels',
            key: 'channels',
            value: 'sports_channels',
            next: 6,
            loading: {
              title: 'Channels',
              description: 'Sports Channels',
            },
          },
          {
            icon: <PhoneIphone />,
            text: 'Premium Channels',
            key: 'Channels',
            value: 'premium_channels',
            next: 6,
            loading: {
              title: 'Brand Service',
              description: 'Internet',
            },
          },
          {
            icon: <PhoneIphone />,
            text: 'Family Channels',
            key: 'Channels',
            value: 'familiy_channels',
            next: 6,
            loading: {
              title: 'Brand Service',
              description: 'Internet',
            },
          },
          {
            icon: <PhoneIphone />,
            text: 'Other Channels',
            key: 'Channels',
            value: 'other_channels',
            next: 6,
            loading: {
              title: 'AT&T Service',
              description: 'Internet',
            },
          },
        ],
      },
    ],
  },
  'fake-formId-for-tests': {
    loadingDelayPerItem: 10,
    steps: [
      {
        title: 'What services are you intersted in?',
        options: [
          {
            icon: <DesktopMac />,
            text: 'Internet',
            key: 'internet',
            value: 'fast',
            next: 2,
            loading: {
              title: 'Brand Service',
              description: 'Internet',
            },
          },
        ],
      },
    ],
  },
}
